import React, { useState } from "react"
import ReactDOM from "react-dom"
const Header = () => {
    return (
        <>
            <h1 id="heading">Google Keep</h1>
        </>
    )
}
export default Header;
